module.exports = __webpack_public_path__ + "static/media/NewiGivXN_color.686ef247.png";